import commonUtil from '../../../utils/commonUtil';

export const UPDATE_CART_LOAD = 'UPDATE_CART_LOAD';
export const UPDATE_CART_LOAD_SUCCESS = 'UPDATE_CART_LOAD_SUCCESS';
export const UPDATE_CART_LOAD_FAIL = 'UPDATE_CART_LOAD_FAIL';

export function loadCartCountData(globalState) {
  return globalState.cartCountData && globalState.cartCountData.loaded;
}

export function getCartCountData() {
  const userEnteredData = {};
  userEnteredData.brandName = commonUtil.getBrand().toUpperCase();
  userEnteredData.channel = commonUtil.getChannel().toUpperCase();
  return {
    types: [UPDATE_CART_LOAD, UPDATE_CART_LOAD_SUCCESS, UPDATE_CART_LOAD_FAIL],
    promise: client => client.post('/api/shoppingCart/getMiniCartDetails', {
      data: (userEnteredData),
    }),
  };
}
